import {AlertController, NavController, LoadingController, Keyboard} from 'ionic-angular';
import {Component} from '@angular/core';
import {UserService} from '../../services/user.services';
import {AppConfigService} from '../../services/appConfig.service';
import {AppDialog} from "../../component/appDialog";
import {ReportWinLossListPage} from "../reportWinLossList/reportWinLossList";

@Component({
    templateUrl: 'reportWinLossSearch.html',
    selector: 'report-win-loss-search-page',
})
export class ReportWinLossSearchPage {
    //排序方式
    status: number = 0;
    starttime: any;
    endtime: string;
    loginName: string;

    constructor(private keyboard: Keyboard, private nav: NavController, public loadingCtrl: LoadingController, private alertCtrl: AlertController, private userService: UserService) {
        this.initService();
    }

    initService() {
        this.userService.reportWinLossInit(undefined, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.starttime = data["stime"];
                this.endtime = data["etime"];
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    searchFn() {
        let requestData: any = {
            order: this.status,
            loginname: this.loginName,
            stime: this.starttime.replace("T", ' ').substr(0, 19),
            etime: this.endtime.replace("T", ' ').substr(0, 19),
        };
        this.userService.reportWinLossSearch(requestData, this).then(data => {
            if (!data["msg"]) {
                this.nav.push(ReportWinLossListPage, {
                    requestData: requestData,
                    data: data
                });
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    ionViewWillLeave() {
        this.keyboard.close();
    }
}



// WEBPACK FOOTER //
// ./src/pages/reportWinLossSearch/reportWinLossSearch.ts